import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import { FlexColumn } from '../../../Reusable/Container';
import BillPaymentsLayout from './BillPaymentsLayout';
import { ErrorAlert } from '../../../Reusable/Alert';
import environment from '../../../../environment';
import { apiPOSTReq, getPreSignedS3Url } from '../../../../Utils/api';
import BG from '../../../../Images/wavey-fingerprint-white.svg';
// import BG from '../../../../Images/bill_bg.svg';

const MainContainer = styled(FlexColumn)`
  /* background-image: url(${props => props.bgImage}); */
  width: 100%;
  height: 100%;
  min-height: calc(117.65vh); /* Adjust based on your header height */
  position: relative;
  overflow: hidden;
  background-color: #efefef;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='24' viewBox='0 0 88 24'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='autumn' fill='%23a168fc' fill-opacity='0.07'%3E%3Cpath d='M10 0l30 15 2 1V2.18A10 10 0 0 0 41.76 0H39.7a8 8 0 0 1 .3 2.18v10.58L14.47 0H10zm31.76 24a10 10 0 0 0-5.29-6.76L4 1 2 0v13.82a10 10 0 0 0 5.53 8.94L10 24h4.47l-6.05-3.02A8 8 0 0 1 4 13.82V3.24l31.58 15.78A8 8 0 0 1 39.7 24h2.06zM78 24l2.47-1.24A10 10 0 0 0 86 13.82V0l-2 1-32.47 16.24A10 10 0 0 0 46.24 24h2.06a8 8 0 0 1 4.12-4.98L84 3.24v10.58a8 8 0 0 1-4.42 7.16L73.53 24H78zm0-24L48 15l-2 1V2.18A10 10 0 0 1 46.24 0h2.06a8 8 0 0 0-.3 2.18v10.58L73.53 0H78z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

  /* forground #b7b7fc */
  /* background-color: #3e484f; */
  /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='24' viewBox='0 0 88 24'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='autumn' fill='%23b7b7fc' fill-opacity='1'%3E%3Cpath d='M10 0l30 15 2 1V2.18A10 10 0 0 0 41.76 0H39.7a8 8 0 0 1 .3 2.18v10.58L14.47 0H10zm31.76 24a10 10 0 0 0-5.29-6.76L4 1 2 0v13.82a10 10 0 0 0 5.53 8.94L10 24h4.47l-6.05-3.02A8 8 0 0 1 4 13.82V3.24l31.58 15.78A8 8 0 0 1 39.7 24h2.06zM78 24l2.47-1.24A10 10 0 0 0 86 13.82V0l-2 1-32.47 16.24A10 10 0 0 0 46.24 24h2.06a8 8 0 0 1 4.12-4.98L84 3.24v10.58a8 8 0 0 1-4.42 7.16L73.53 24H78zm0-24L48 15l-2 1V2.18A10 10 0 0 1 46.24 0h2.06a8 8 0 0 0-.3 2.18v10.58L73.53 0H78z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"); */

  /* background-color: #f1f1f1; */
/* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='24' viewBox='0 0 88 24'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='autumn' fill='%23b7b7fc' fill-opacity='0.39'%3E%3Cpath d='M10 0l30 15 2 1V2.18A10 10 0 0 0 41.76 0H39.7a8 8 0 0 1 .3 2.18v10.58L14.47 0H10zm31.76 24a10 10 0 0 0-5.29-6.76L4 1 2 0v13.82a10 10 0 0 0 5.53 8.94L10 24h4.47l-6.05-3.02A8 8 0 0 1 4 13.82V3.24l31.58 15.78A8 8 0 0 1 39.7 24h2.06zM78 24l2.47-1.24A10 10 0 0 0 86 13.82V0l-2 1-32.47 16.24A10 10 0 0 0 46.24 24h2.06a8 8 0 0 1 4.12-4.98L84 3.24v10.58a8 8 0 0 1-4.42 7.16L73.53 24H78zm0-24L48 15l-2 1V2.18A10 10 0 0 1 46.24 0h2.06a8 8 0 0 0-.3 2.18v10.58L73.53 0H78z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"); */
`;

class BillPaymentsContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            bill: this.props.bill || {},
            vendor: this.props.vendor || {},
            billUrl: null,
            viewMode: true,  // Default to view details mode
            payMode: false,     // Pay mode is initially off
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
    }

    handleBack = () => {
        this.props.history.goBack();
    };

    // Toggle between view details and pay mode
    handleViewModeChange = (viewMode, payMode) => {
        this.setState({ viewMode, payMode });
    };

    render() {
        const { bill, vendor, billUrl, loading, viewMode, payMode } = this.state;

        return (
            <MainContainer bgImage={BG}>
                <BillPaymentsLayout
                    bill={bill}
                    vendor={vendor}
                    onBack={this.handleBack}
                    onSave={this.handleSave}
                    onClose={this.props.onClose}
                    onPay={this.handlePay}
                    onViewModeChange={this.handleViewModeChange}
                />
            </MainContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        userDefaultsStore: state.userDefaultsReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(BillPaymentsContainer)));